<ion-button
  expand="block"
  class="google-button mb-3"
  (click)="login()"
  ><ion-img src="../assets/icon/google.svg" class="google-icon"></ion-img> Sign in with
  Google</ion-button
>
